import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, withKeys as _withKeys, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-98d3b8f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "order" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("订单管理")
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "serach-box" }
const _hoisted_5 = { class: "item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc" }, "学生姓名：", -1))
const _hoisted_7 = { class: "input" }
const _hoisted_8 = { class: "item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc" }, "研究生姓名：", -1))
const _hoisted_10 = { class: "input" }
const _hoisted_11 = { class: "item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc" }, "订单状态：", -1))
const _hoisted_13 = { class: "input" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 新建 ")
const _hoisted_16 = { class: "table" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" 身份证号: ")
const _hoisted_18 = { key: 0 }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" 报名时间: ")
const _hoisted_20 = { key: 0 }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("匹配中")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("上课中")
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" 转课 ")
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" 续课 ")
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" 退费 ")
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" 结课 ")
const _hoisted_27 = { key: 0 }
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" 查看 ")
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" 新建 ")
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" 未签订 ")
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" 已签订 ")
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" 点此查看 ")
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" 暂未上传 ")
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" 未签订 ")
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" 已签订 ")
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" 点击查看 ")
const _hoisted_37 = { key: 0 }
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" 查看 ")
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" 查看 ")
const _hoisted_40 = /*#__PURE__*/_createTextVNode(" 修改 ")
const _hoisted_41 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_42 = { class: "pagination" }
const _hoisted_43 = /*#__PURE__*/_createTextVNode(" (选项中若没有，可输入关键字搜索) ")
const _hoisted_44 = /*#__PURE__*/_createTextVNode(" (选项中若没有，可输入关键字搜索) ")
const _hoisted_45 = /*#__PURE__*/_createTextVNode("选择文件")
const _hoisted_46 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_47 = /*#__PURE__*/_createTextVNode(" 确定 ")
const _hoisted_48 = /*#__PURE__*/_createTextVNode(" (选项中若没有，可输入关键字搜索) ")
const _hoisted_49 = /*#__PURE__*/_createTextVNode(" (选项中若没有，可输入关键字搜索) ")
const _hoisted_50 = /*#__PURE__*/_createTextVNode("选择文件")
const _hoisted_51 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_52 = /*#__PURE__*/_createTextVNode(" 确定 ")

import { onMounted, ref } from "vue";
import { useRouter, useRoute } from "vue-router";
import { ElMessage } from "element-plus";
import type { ElForm } from "element-plus";
import {
  getOrderList,
  createOrder,
  getXuejieList,
  getJiaoWuList,
  getClassTypeList,
  uploadImg,
  getStudentList,
  getPostgraList,
  updateOrder,
} from "../../config/interface";
type FormInstance = InstanceType<typeof ElForm>;

// #region 定义状态

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();
const route = useRoute();
const ruleFormRef = ref<FormInstance>();
const ruleFormRef2 = ref<FormInstance>();
const pageSize = ref<Number>(10); // 每页展示条数
const currentPage = ref(""); // 当前页数
const totalPage = ref(0); // 列表总数
const dialogVisible = ref<Boolean>(false); // 控制修改对话框显示状态
const dialogVisible2 = ref(false); // 新增对话框状态
const insertLoading = ref(false); // 新建对话框中的确认按钮loading状态
const editLoading = ref(false); // 修改对话框中的确认按钮loading状态
// 筛选条件
const search = ref({
  sName: "",
  pName: "",
  orderStatus: "",
});
const tableData = ref([]); // 表格数据
const orderInfo = ref<any>({}); // 临时存放修改订单的信息，每次使用前需清空
const createOrderInfo = ref<any>({}); // 临时存放新建订单的信息，每次使用前需要清空
// 表单校验规则
const rules = {
  classId: [{ required: true, message: "请输入班级编号", trigger: "blur" }],
  sId: [{ required: true, message: "请选择学员姓名", trigger: "change" }],
  orderStatus: [
    { required: true, message: "请选择订单状态", trigger: "change" },
  ],
  subject: [{ required: true, message: "请输入辅导科目", trigger: "blur" }],
  addHour: [{ required: true, message: "请输入订单金额", trigger: "blur" }],
  cId: [{ required: true, message: "请选择班级类型", trigger: "change" }],
  totalFee: [{ required: true, message: "请输入订单金额", trigger: "blur" }],
  pId: [{ required: true, message: "请选择研究生", trigger: "change" }],
  jId: [{ required: true, message: "请选择教务", trigger: "change" }],
  gId: [{ required: true, message: "请选择顾问", trigger: "change" }],
};
const rules2 = {
  classId: [{ required: true, message: "请输入班级编号", trigger: "blur" }],
  sId: [{ required: true, message: "请选择学员姓名", trigger: "change" }],
  subject: [{ required: true, message: "请输入辅导科目", trigger: "blur" }],
  cId: [{ required: true, message: "请选择班级类型", trigger: "change" }],
  totalFee: [{ required: true, message: "请输入订单金额", trigger: "blur" }],
  pId: [{ required: true, message: "请选择研究生", trigger: "change" }],
  jId: [{ required: true, message: "请选择教务", trigger: "change" }],
  gId: [{ required: true, message: "请选择顾问", trigger: "change" }],
};
const cardFile = ref([] as any); // 教学计划文件列表
const xuejieArr = ref([] as any); // 顾问列表
const jiaowuArr = ref([] as any); // 教务列表
const classTypeArr = ref([] as any); // 班级类型列表
const tableLoading = ref(false); // 表格loading状态
const studentArr = ref([] as any); // 学生列表
const postgraArr = ref([] as any); // 研究生列表
// #endregion
const tableRowClassName = ({ row }) => {
  if (row.orderStatus == 6) {
    return "success-row";
  } else if (row.orderStatus == 5) {
    return "warning-row";
  } else {
    return "";
  }
}

// #region 定义方法
// 新建订单
const handleInsert = (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  formEl.validate((valid) => {
    if (valid) {
      console.log(createOrderInfo.value);
      insertLoading.value = true;
      createOrder(createOrderInfo.value).then((res) => {
        if (res.data && res.data.success) {
          insertLoading.value = false;
          ElMessage.success(res.data.data);
          dialogVisible2.value = false;
          createOrderInfo.value = {};
          getList(
            "1",
            search.value.sName,
            search.value.pName,
            search.value.orderStatus,
            ""
          );
          // window.location.reload();
        } else {
          ElMessage.error(res.data.msg);
        }
      });
    } else {
      console.log("error submit!");
      return false;
    }
  });
};
// 新建订单按钮，清空数据，显示对话框
const handleCreate = () => {
  createOrderInfo.value = {};
  dialogVisible2.value = true;
};
// 选择研究生下拉框的输入监听事件
const handleSelectPostgra = (val: any) => {
  getPostgra(val.data);
};
// 选择学员下拉框的输入监听事件
const handleSelectStudent = (val: any) => {
  getStudent(val.data);
};
// 列表中的删除按钮，该功能暂未添加
const handleDelete = () => {
  ElMessage.info("该功能暂未开放");
};
// 修改订单的上传教学计划
const uploadCardFile = (file: any) => {
  const form = new FormData();
  form.append("file", file.file);
  form.append("classfication", "3");
  for (var value of form.values()) {
    console.log(value);
  }
  uploadImg(form).then((res) => {
    console.log(res);
    if (res.data.success) {
      orderInfo.posPlan = res.data.data;
      ElMessage.success("上传成功");
    } else {
      ElMessage.error(res.data.msg);
    }
  });
};
// 新建订单的上传教学计划
const uploadCardFile2 = (file: any) => {
  const form = new FormData();
  form.append("file", file.file);
  form.append("classfication", "3");
  for (var value of form.values()) {
    console.log(value);
  }
  uploadImg(form).then((res) => {
    console.log(res);
    if (res.data.success) {
      createOrderInfo.value.posPlan = res.data.data;
      ElMessage.success("上传成功");
    } else {
      ElMessage.error(res.data.msg);
    }
  });
};
// 研究生教学计划，点击查看，浏览器打开新页标签
const handleShowPlanDetail = (url: string) => {
  if (url) {
    window.open(url);
  }
};
// 回访计划，点击设置，跳转到新建回访计划页面
// const toCreatePlan = (coId: number) => {
//   router.push({
//     path: "/order/createPlan",
//     query: { coId },
//   });
// };
// 回访计划，点击查看，跳转到回访计划页面
const toPlan = (coId: number) => {
  router.push({
    path: "/order/plan",
    query: { coId },
  });
};
// 回访记录，点击跳转到消息页面
const toMessage = (coId: number) => {
  router.push({
    path: "/order/visitRecord",
    query: { coId },
  });
};
// 点击修改弹框的确认按钮，请求修改接口
const handleEdit = (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  formEl.validate((valid) => {
    if (valid) {
      let params = {
        coId: orderInfo.value.id,
        classId: orderInfo.value.classId,
        sId: orderInfo.value.sId,
        pId: orderInfo.value.pId,
        cId: orderInfo.value.cId,
        jId: orderInfo.value.jId,
        gId: orderInfo.value.gId,
        subject: orderInfo.value.subject,
        sProcess: orderInfo.value.sProcess,
        pProcess: orderInfo.value.pProcess,
        requirement: orderInfo.value.requirement,
        posPlan: orderInfo.value.posPlan,
        orderStatus: orderInfo.value.orderStatus,
        posRemark: orderInfo.value.posRemark,
        orderRemark: orderInfo.value.orderRemark,
        addHour: orderInfo.value.addHour,
        totalFee: orderInfo.value.totalFee,
      };
      editLoading.value = true;
      updateOrder(params).then((res) => {
        console.log(res);
        getList(
          "1",
          search.value.sName,
          search.value.pName,
          search.value.orderStatus,
          ""
        );
        dialogVisible.value = false;
        editLoading.value = false;
      });
    } else {
      console.log("error submit!");
      return false;
    }
  });
};
// 点击修改按钮，赋值变量，弹出对话框
const handleShowEdit = (val: any) => {
  // 将直接赋值改为深拷贝，这样不会影响表格中的数据
  orderInfo.value = JSON.parse(JSON.stringify(val));
  xuejieArr.value.map((item: any) => {
    if (item.xjNickname === orderInfo.value.gName) {
      orderInfo.value.gId = item.id;
    }
  });
  dialogVisible.value = true;
};
// 点击搜索按钮，请求接口
const handleSearch = () => {
  console.log("条件筛选");
  console.log(search);
  getList(
    "1",
    search.value.sName,
    search.value.pName,
    search.value.orderStatus,
    ""
  );
};
// 点击表格中的查看上课记录，跳转到上课记录页面
const toRecord = (coId: number) => {
  router.push({
    path: "/order/record",
    query: { coId },
  });
};
// 点击表格中的新建上课记录，跳转到新建记录页面
const toCreate = (coId: number) => {
  router.push({
    path: "/order/createRecord",
    query: { coId },
  });
};
// 结算记录，暂未实装
const handleShowSettlement = () => {
  console.log("查看结算记录");
};
// 改变每页数量,请求列表数据接口
const handleSizeChange = (val: number) => {
  pageSize.value = val;
  console.log(pageSize.value);
};
// 点击分页按钮,请求列表数据接口
const handleCurrentChange = (val: string) => {
  currentPage.value = val as string;
  console.log(currentPage.value);
  getList(
    val,
    search.value.sName,
    search.value.pName,
    search.value.orderStatus,
    ""
  );
};
// 获取订单列表
const getList = (
  pageNum: string,
  sName: string,
  pName: string,
  orderStatus: string,
  id: string
) => {
  tableLoading.value = true;
  let params = {
    pageNum,
    sName,
    pName,
    orderStatus,
    id,
  };
  getOrderList(params).then((res) => {
    if (res.data && res.data.success) {
      tableLoading.value = false;
      tableData.value = res.data.data.list;
      totalPage.value = res.data.data.total;
    } else {
      ElMessage.error(res.data.msg);
    }
  });
};
// 获取学生列表，在修改或新增对话框中选择
const getStudent = (sName: string) => {
  let params = {
    pageNum: 1,
    sName,
    type: 2
  };
  getStudentList(params).then((res: any) => {
    if (res.data && res.data.success) {
      studentArr.value = res.data.data.list;
    } else {
      ElMessage.error(res.data.msg);
    }
  });
};
// 获取研究生列表，在修改或新增对话框中选择
const getPostgra = (name: string) => {
  let params = {
    pageNum: 1,
    name,
    pageSize: 10
  };
  getPostgraList(params).then((res) => {
    if (res.data && res.data.success) {
      postgraArr.value = res.data.data.list;
    } else {
      ElMessage.error(res.data.msg);
    }
  });
};
// #endregion

onMounted(() => {
  getList(
    "1",
    search.value.sName,
    search.value.pName,
    search.value.orderStatus,
    route.params.id as string
  );
  getStudent("");
  getPostgra("");
  getXuejieList({ nickName: "" }).then((res) => {
    xuejieArr.value = res.data.data;
  });
  getJiaoWuList({}).then((res) => {
    jiaowuArr.value = res.data.data;
  });
  getClassTypeList({}).then((res) => {
    classTypeArr.value = res.data.data;
  });
});

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_tag, { type: "success" }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_el_input, {
              modelValue: search.value.sName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search.value.sName) = $event)),
              placeholder: "输入学生姓名",
              clearable: "",
              onKeyup: _withKeys(handleSearch, ["enter"])
            }, null, 8, ["modelValue", "onKeyup"])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_el_input, {
              modelValue: search.value.pName,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((search.value.pName) = $event)),
              placeholder: "输入研究生",
              clearable: "",
              onKeyup: _withKeys(handleSearch, ["enter"])
            }, null, 8, ["modelValue", "onKeyup"])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_el_select, {
              modelValue: search.value.orderStatus,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((search.value.orderStatus) = $event)),
              placeholder: "选择订单状态"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "匹配中",
                  value: "1"
                }),
                _createVNode(_component_el_option, {
                  label: "上课中",
                  value: "2"
                }),
                _createVNode(_component_el_option, {
                  label: "转课",
                  value: "3"
                }),
                _createVNode(_component_el_option, {
                  label: "续课",
                  value: "4"
                }),
                _createVNode(_component_el_option, {
                  label: "退费",
                  value: "5"
                }),
                _createVNode(_component_el_option, {
                  label: "结课",
                  value: "6"
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleSearch
        }, {
          default: _withCtx(() => [
            _hoisted_14
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_el_button, {
        type: "primary",
        style: {"width":"100px"},
        onClick: handleCreate
      }, {
        default: _withCtx(() => [
          _hoisted_15
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_16, [
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: tableData.value,
        border: "",
        style: {"width":"100%"},
        "row-class-name": tableRowClassName
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            fixed: "",
            prop: "classId",
            align: "center",
            label: "班级编号",
            width: "80"
          }),
          _createVNode(_component_el_table_column, {
            fixed: "",
            prop: "sName",
            label: "学员姓名",
            width: "100",
            "show-overflow-tooltip": "",
            align: "center"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_popover, {
                effect: "light",
                trigger: "hover",
                placement: "right",
                width: "auto"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, "学员姓名: " + _toDisplayString(scope.row.sName), 1),
                  _createElementVNode("div", null, "手机号码: " + _toDisplayString(scope.row.sPhone), 1),
                  _createElementVNode("div", null, "邮箱地址: " + _toDisplayString(scope.row.email), 1),
                  _createElementVNode("div", null, [
                    _hoisted_17,
                    ( scope.row.idCard )
                      ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(scope.row.idCard.slice(0, 6)) + " **** " + _toDisplayString(scope.row.idCard.slice(16, 19)), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", null, "本科院校: " + _toDisplayString(scope.row.college), 1),
                  _createElementVNode("div", null, "本科专业: " + _toDisplayString(scope.row.major), 1),
                  _createElementVNode("div", null, "目标院校: " + _toDisplayString(scope.row.targetCollege), 1),
                  _createElementVNode("div", null, "目标院系: " + _toDisplayString(scope.row.targetAcademy), 1),
                  _createElementVNode("div", null, "目标专业: " + _toDisplayString(scope.row.targetMajor), 1),
                  _createElementVNode("div", null, "班型: " + _toDisplayString(scope.row.cName), 1),
                  _createElementVNode("div", null, "金额: " + _toDisplayString(scope.row.totalFee), 1),
                  _createElementVNode("div", null, "研究生: " + _toDisplayString(scope.row.pName), 1),
                  _createElementVNode("div", null, "研究生备注: " + _toDisplayString(scope.row.pRemarks), 1),
                  _createElementVNode("div", null, "教务: " + _toDisplayString(scope.row.jName), 1),
                  _createElementVNode("div", null, "顾问: " + _toDisplayString(scope.row.gName), 1),
                  _createElementVNode("div", null, "订单备注: " + _toDisplayString(scope.row.remarks), 1),
                  _createElementVNode("div", null, [
                    _hoisted_19,
                    ( scope.row.signTime )
                      ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(scope.row.signTime.slice(0, 10)), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                reference: _withCtx(() => [
                  _createElementVNode("div", null, _toDisplayString(scope.row.sName), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "orderStatus",
            label: "订单状态",
            width: "100"
          }, {
            default: _withCtx(( scope ) => [
              ( scope.row.orderStatus === '1' )
                ? (_openBlock(), _createBlock(_component_el_tag, { key: 0 }, {
                    default: _withCtx(() => [
                      _hoisted_21
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              ( scope.row.orderStatus === '2' )
                ? (_openBlock(), _createBlock(_component_el_tag, { key: 1 }, {
                    default: _withCtx(() => [
                      _hoisted_22
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              ( scope.row.orderStatus === '3' )
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 2,
                    type: "warning"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_23
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              ( scope.row.orderStatus === '4' )
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 3,
                    type: "success"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_24
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              ( scope.row.orderStatus === '5' )
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 4,
                    type: "danger"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_25
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              ( scope.row.orderStatus === '6' )
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 5,
                    type: "info"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_26
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "subject",
            label: "辅导科目",
            width: "100"
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: " addHour",
            label: "累计/剩余课时",
            width: "120"
          }, {
            default: _withCtx(( scope ) => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(classTypeArr.value, (item, index) => {
                return (_openBlock(), _createElementBlock("span", {
                  key:  index 
                }, [
                  ( scope.row.cId === item.id )
                    ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(scope.row.addHour) + " / " + _toDisplayString(item.cnum - scope.row.addHour), 1))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "sRecord",
            label: "上课记录",
            width: "110"
          }, {
            default: _withCtx(( scope ) => [
              _createVNode(_component_el_button, {
                type: "text",
                onClick: ($event: any) => ( toRecord(scope.row.id) )
              }, {
                default: _withCtx(() => [
                  _hoisted_28
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_button, {
                type: "text",
                onClick: ($event: any) => ( toCreate(scope.row.id) )
              }, {
                default: _withCtx(() => [
                  _hoisted_29
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            "show-overflow-tooltip": "",
            prop: "cName",
            label: "班级类型",
            width: "180"
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "totalFee",
            label: "金额",
            width: "100"
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "sProcess",
            label: "学员协议进度",
            width: "150"
          }, {
            default: _withCtx(( scope ) => [
              ( scope.row.sProcess === '0' )
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 0,
                    type: "warning"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_30
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              ( scope.row.sProcess === '1' )
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 1,
                    type: "success"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_31
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "pName",
            label: "研究生",
            width: "100"
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "posPlan",
            label: "教学计划",
            width: "110"
          }, {
            default: _withCtx(( scope ) => [
              ( scope.row.posPlan )
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    type: "text",
                    onClick: ($event: any) => ( handleShowPlanDetail(scope.row.posPlan) )
                  }, {
                    default: _withCtx(() => [
                      _hoisted_32
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : (_openBlock(), _createBlock(_component_el_button, {
                    key: 1,
                    type: "text"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_33
                    ]),
                    _: 1
                  }))
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "pProcess",
            label: "研究生协议进度",
            width: "130"
          }, {
            default: _withCtx(( scope ) => [
              ( scope.row.pProcess === '0' )
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 0,
                    type: "warning"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_34
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              ( scope.row.pProcess === '1' )
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 1,
                    type: "success"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_35
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            label: "结算记录",
            width: "90"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "text",
                onClick:  handleShowSettlement 
              }, {
                default: _withCtx(() => [
                  _hoisted_36
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "jName",
            label: "教务",
            width: "100"
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "gName",
            label: "顾问",
            width: "100"
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "signTime",
            label: "报名时间",
            width: "120"
          }, {
            default: _withCtx(( scope ) => [
              ( scope.row.signTime )
                ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(scope.row.signTime.slice(0, 10)), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "requirement",
            label: "学员备注",
            "show-overflow-tooltip": "",
            width: "100"
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "posRemark",
            label: "研究生备注",
            "show-overflow-tooltip": "",
            width: "120"
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            prop: "orderRemark",
            label: "订单备注",
            "show-overflow-tooltip": "",
            width: "120"
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            label: "回访计划",
            fixed: "right",
            width: "110"
          }, {
            default: _withCtx(( scope ) => [
              _createVNode(_component_el_button, {
                type: "text",
                onClick: ($event: any) => ( toPlan(scope.row.id) )
              }, {
                default: _withCtx(() => [
                  _hoisted_38
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            label: "回访记录",
            fixed: "right",
            width: "90"
          }, {
            default: _withCtx(( scope ) => [
              _createVNode(_component_el_button, {
                type: "text",
                onClick: ($event: any) => ( toMessage(scope.row.id) )
              }, {
                default: _withCtx(() => [
                  _hoisted_39
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            label: "操作",
            fixed: "right",
            width: "150"
          }, {
            default: _withCtx(( scope ) => [
              _createVNode(_component_el_button, {
                size: "small",
                type: "primary",
                onClick: ($event: any) => ( handleShowEdit(scope.row) )
              }, {
                default: _withCtx(() => [
                  _hoisted_40
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_popconfirm, {
                title: "是否删除该条学员信息?",
                onConfirm: _cache[3] || (_cache[3] = ($event: any) => ( handleDelete() ))
              }, {
                reference: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "danger",
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_41
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])), [
        [_directive_loading, tableLoading.value]
      ])
    ]),
    _createElementVNode("div", _hoisted_42, [
      _createVNode(_component_el_pagination, {
        "page-sizes":  [100, 200, 300, 400] ,
        "page-size":  pageSize.value ,
        "current-page":  currentPage.value ,
        background: "",
        layout: "total, prev, pager, next, sizes",
        total:  totalPage.value ,
        onSizeChange:  handleSizeChange ,
        onCurrentChange:  handleCurrentChange 
      }, null, 8, ["page-size", "current-page", "total", "onSizeChange", "onCurrentChange"])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue:  dialogVisible.value ,
      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (( dialogVisible.value ) = $event)),
      title: "修改订单信息",
      width: "600px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref_key: "ruleFormRef",
          ref: ruleFormRef,
          rules:  rules ,
          model:  orderInfo.value ,
          "label-width": "120px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "班级编号",
              prop: "classId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue:  orderInfo.value.classId ,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (( orderInfo.value.classId ) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "学员姓名",
              prop: "sId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue:  orderInfo.value.sId ,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (( orderInfo.value.sId ) = $event)),
                  filterable: "",
                  onInput:  handleSelectStudent 
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(studentArr.value, (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key:  index ,
                        label:  item.sName ,
                        value:  item.id 
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "onInput"]),
                _createVNode(_component_el_button, {
                  style: {"margin-left":"10px"},
                  type: "text",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _hoisted_43
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "订单状态",
              prop: "orderStatus"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue:  orderInfo.value.orderStatus ,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (( orderInfo.value.orderStatus ) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "匹配中",
                      value: "1"
                    }),
                    _createVNode(_component_el_option, {
                      label: "上课中",
                      value: "2"
                    }),
                    _createVNode(_component_el_option, {
                      label: "转课",
                      value: "3"
                    }),
                    _createVNode(_component_el_option, {
                      label: "续课",
                      value: "4"
                    }),
                    _createVNode(_component_el_option, {
                      label: "退费",
                      value: "5"
                    }),
                    _createVNode(_component_el_option, {
                      label: "结课",
                      value: "6"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "辅导科目",
              prop: "subject"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue:  orderInfo.value.subject ,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (( orderInfo.value.subject ) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "累计课时",
              prop: "addHour"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue:  orderInfo.value.addHour ,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (( orderInfo.value.addHour ) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "班级类型",
              prop: "cId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue:  orderInfo.value.cId ,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (( orderInfo.value.cId ) = $event)),
                  style: {"width":"305px"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(classTypeArr.value, (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key:  index ,
                        label:  item.feeType + item.cname ,
                        value:  item.id 
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "订单金额",
              prop: "totalFee"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue:  orderInfo.value.totalFee ,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (( orderInfo.value.totalFee ) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "学员协议",
              prop: "sProcess"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue:  orderInfo.value.sProcess ,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (( orderInfo.value.sProcess ) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "未签订",
                      value: "0"
                    }),
                    _createVNode(_component_el_option, {
                      label: "已签订",
                      value: "1"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "研究生姓名",
              prop: "pId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue:  orderInfo.value.pId ,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (( orderInfo.value.pId ) = $event)),
                  filterable: "",
                  placeholder: "请选择研究生",
                  onInput:  handleSelectPostgra 
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(postgraArr.value, (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key:  index ,
                        label:  item.name ,
                        value:  item.id 
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "onInput"]),
                _createVNode(_component_el_button, {
                  style: {"margin-left":"10px"},
                  type: "text",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _hoisted_44
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "研究生协议",
              prop: "pProcess"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue:  orderInfo.value.pProcess ,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (( orderInfo.value.pProcess ) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "未签订",
                      value: "0"
                    }),
                    _createVNode(_component_el_option, {
                      label: "已签订",
                      value: "1"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "教务姓名",
              prop: "jId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue:  orderInfo.value.jId ,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (( orderInfo.value.jId ) = $event)),
                  placeholder: "请选择教务"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(jiaowuArr.value, (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key:  index ,
                        label:  item.jname ,
                        value:  item.id 
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "顾问姓名",
              prop: "gId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue:  orderInfo.value.gId ,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (( orderInfo.value.gId ) = $event)),
                  filterable: "",
                  placeholder: "请选择顾问"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(xuejieArr.value, (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key:  index ,
                        label:  item.xjNickname ,
                        value:  item.id 
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "教学计划",
              prop: "posPlan"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_upload, {
                  action: "#",
                  limit:  1 ,
                  "http-request":  uploadCardFile ,
                  "file-list":  cardFile.value 
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, { type: "primary" }, {
                      default: _withCtx(() => [
                        _hoisted_45
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["http-request", "file-list"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "学员备注",
              prop: "requirement"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue:  orderInfo.value.requirement ,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (( orderInfo.value.requirement ) = $event)),
                  type: "textarea",
                  autosize: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "研究生备注",
              prop: "posRemark"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue:  orderInfo.value.posRemark ,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (( orderInfo.value.posRemark ) = $event)),
                  type: "textarea",
                  autosize: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "订单备注",
              prop: "orderRemark"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue:  orderInfo.value.orderRemark ,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (( orderInfo.value.orderRemark ) = $event)),
                  type: "textarea",
                  autosize: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  onClick: _cache[19] || (_cache[19] = ($event: any) => ( dialogVisible.value = false ))
                }, {
                  default: _withCtx(() => [
                    _hoisted_46
                  ]),
                  _: 1
                }),
                _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                  type: "primary",
                  onClick: _cache[20] || (_cache[20] = ($event: any) => ( handleEdit(ruleFormRef.value) ))
                }, {
                  default: _withCtx(() => [
                    _hoisted_47
                  ]),
                  _: 1
                })), [
                  [
                    _directive_loading,
                     editLoading.value ,
                    void 0,
                    {
                      fullscreen: true,
                      lock: true
                    }
                  ]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["rules", "model"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue:  dialogVisible2.value ,
      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => (( dialogVisible2.value ) = $event)),
      title: "新增订单",
      width: "600px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref_key: "ruleFormRef2",
          ref: ruleFormRef2,
          rules:  rules2 ,
          model:  createOrderInfo.value ,
          "label-width": "120px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "班级编号",
              prop: "classId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue:  createOrderInfo.value.classId ,
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (( createOrderInfo.value.classId ) = $event)),
                  placeholder: "请输入班级编号"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "学员姓名",
              prop: "sId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue:  createOrderInfo.value.sId ,
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (( createOrderInfo.value.sId ) = $event)),
                  filterable: "",
                  placeholder: "请选择学员",
                  onInput:  handleSelectStudent 
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(studentArr.value, (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key:  index ,
                        label:  item.sName ,
                        value:  item.id 
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "onInput"]),
                _createVNode(_component_el_button, {
                  style: {"margin-left":"10px"},
                  type: "text",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _hoisted_48
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "辅导科目",
              prop: "subject"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue:  createOrderInfo.value.subject ,
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (( createOrderInfo.value.subject ) = $event)),
                  placeholder: "请输入辅导科目"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "班级类型",
              prop: "cId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue:  createOrderInfo.value.cId ,
                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (( createOrderInfo.value.cId ) = $event)),
                  placeholder: "请选择班级类型",
                  style: {"width":"305px"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(classTypeArr.value, (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key:  index ,
                        label:  item.feeType + item.cname ,
                        value:  item.id 
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "订单金额",
              prop: "totalFee"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue:  createOrderInfo.value.totalFee ,
                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (( createOrderInfo.value.totalFee ) = $event)),
                  placeholder: "请输入订单金额"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "研究生姓名",
              prop: "pId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue:  createOrderInfo.value.pId ,
                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (( createOrderInfo.value.pId ) = $event)),
                  filterable: "",
                  placeholder: "请选择研究生",
                  onInput:  handleSelectPostgra 
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(postgraArr.value, (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key:  index ,
                        label:  item.name ,
                        value:  item.id 
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "onInput"]),
                _createVNode(_component_el_button, {
                  style: {"margin-left":"10px"},
                  type: "text",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _hoisted_49
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "教务姓名",
              prop: "jId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue:  createOrderInfo.value.jId ,
                  "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (( createOrderInfo.value.jId ) = $event)),
                  placeholder: "请选择教务"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(jiaowuArr.value, (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key:  index ,
                        label:  item.jname ,
                        value:  item.id 
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "顾问姓名",
              prop: "gId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue:  createOrderInfo.value.gId ,
                  "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (( createOrderInfo.value.gId ) = $event)),
                  filterable: "",
                  placeholder: "请选择顾问"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(xuejieArr.value, (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key:  index ,
                        label:  item.xjNickname ,
                        value:  item.id 
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "教学计划",
              prop: "posPlan"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_upload, {
                  action: "#",
                  limit:  1 ,
                  "http-request":  uploadCardFile2 ,
                  "file-list":  cardFile.value 
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, { type: "primary" }, {
                      default: _withCtx(() => [
                        _hoisted_50
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["http-request", "file-list"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "学员备注" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue:  createOrderInfo.value.requirement ,
                  "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (( createOrderInfo.value.requirement ) = $event)),
                  placeholder: "请输入学员备注"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "研究生备注" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue:  createOrderInfo.value.posRemark ,
                  "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (( createOrderInfo.value.posRemark ) = $event)),
                  placeholder: "请输入研究生备注"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "订单备注" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue:  createOrderInfo.value.orderRemark ,
                  "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => (( createOrderInfo.value.orderRemark ) = $event)),
                  placeholder: "请输入订单备注"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  onClick: _cache[33] || (_cache[33] = ($event: any) => ( dialogVisible2.value = false ))
                }, {
                  default: _withCtx(() => [
                    _hoisted_51
                  ]),
                  _: 1
                }),
                _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                  type: "primary",
                  onClick: _cache[34] || (_cache[34] = ($event: any) => ( handleInsert(ruleFormRef2.value) ))
                }, {
                  default: _withCtx(() => [
                    _hoisted_52
                  ]),
                  _: 1
                })), [
                  [
                    _directive_loading,
                     insertLoading.value ,
                    void 0,
                    {
                      fullscreen: true,
                      lock: true
                    }
                  ]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["rules", "model"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})